import { RouteReuseStrategy } from '@angular/router';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { environment } from 'src/environments/environment';
import { HttpClientModule } from '@angular/common/http';
import { RechnerPageModule } from './rechner/rechner.module';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PlatformModule } from '@angular/cdk/platform';
import { PercentagePipe } from './services/pipes/percentage.pipe';
import { BigDecimal } from './global';
import {IonicModule, IonicRouteStrategy} from '@ionic/angular';

@NgModule({
  declarations: [AppComponent, PercentagePipe],

  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule,
    HttpClientModule,
    RechnerPageModule,
    FormsModule,
    FontAwesomeModule,
    BrowserAnimationsModule,
    PlatformModule,
  ],

  providers: [
    {
      provide: [ RouteReuseStrategy, BigDecimal],
      useClass: IonicRouteStrategy,
    },
  ],
  exports: [MatDialogModule],
  bootstrap: [AppComponent],
})
export class AppModule {}
